<template lang="html">
    <div class="container-fluid p-5">
         <div class="row mt-2">
            <div class="col-md-12">
                <span id="agent-url">
                    https://ballxbet.com?agent={{ user ? user.code : '' }}
                </span>
                <button class="btn btn-sm btn-outline-primary ms-2" @click="copyAgentUrl">Copy</button>
                <span v-if="copied" class="text-success ms-2">Copied!</span>
            </div>
         </div>
        <div class="row mt-2">
            <div class="col-md-3">
                <div class="card" style="width: 100%;">
                     <div class="card-header title-font-size">Total Member</div>
                    <div class="card-body">
                        <p class="card-text card-font-size">{{dashboard.total_users}}</p>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card" style="width: 100%;">
                     <div class="card-header title-font-size">Total Commissions</div>
                    <div class="card-body">
                        <p class="card-text card-font-size">{{dashboard.total_agent_commission}}</p>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card" style="width: 100%;">
                     <div class="card-header title-font-size">Total Withdrawals</div>
                    <div class="card-body">
                        <p class="card-text card-font-size">{{dashboard.today_agent_commission_withdrawn}}</p>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card" style="width: 100%;">
                     <div class="card-header title-font-size">Total Bet Amount</div>
                    <div class="card-body">
                        <p class="card-text card-font-size">{{dashboard.total_bet_amount}}</p>
                    </div>
                </div>
            </div>
        </div>
         <div class="row mt-2">
            <div class="col-md-3">
                <div class="card" style="width: 100%;">
                     <div class="card-header title-font-size">Today Registered Users</div>
                    <div class="card-body">
                        <p class="card-text card-font-size">{{dashboard.today_registered_users}}</p>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card" style="width: 100%;">
                     <div class="card-header title-font-size">Today Commissions</div>
                    <div class="card-body">
                        <p class="card-text card-font-size">{{dashboard.today_agent_commission}}</p>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card" style="width: 100%;">
                     <div class="card-header title-font-size">Today Withdrawals</div>
                    <div class="card-body">
                        <p class="card-text card-font-size">{{dashboard.today_agent_commission_withdrawn}}</p>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card" style="width: 100%;">
                     <div class="card-header title-font-size">Today Bet Amount</div>
                    <div class="card-body">
                        <p class="card-text card-font-size">{{dashboard.today_bet_amount}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="js">
    import {
        mapState,
        mapActions
    } from 'vuex'
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css'
    import DashboardHeader from '@/components/DashboardHeader.vue'
    export default {
        name: 'dashboard',
        metaInfo: {
            title: "Home",
            titleTemplate: "%s ← BKK Dashboard",
        },
        components: {
            Loading,
            DashboardHeader
        },
        data() {
            return {
                isLoading: false,
                fullPage: true,
                dashboard: [],
                user: null,
                copied: false,
            }
        },
        computed: {
            ...mapState({})
        },
        methods: {
            ...mapActions({
                agentDashboardAction: 'agentDashboardAction',
            }),
            copyAgentUrl() {
                const url = `https://ballxbet.com?agent=${this.user ? this.user.code : ''}`;
                if (navigator.clipboard) {
                    navigator.clipboard.writeText(url).then(() => {
                        this.copied = true;
                        setTimeout(() => this.copied = false, 1500);
                    });
                } else {
                    // fallback for older browsers
                    const el = document.createElement('textarea');
                    el.value = url;
                    document.body.appendChild(el);
                    el.select();
                    document.execCommand('copy');
                    document.body.removeChild(el);
                    this.copied = true;
                    setTimeout(() => this.copied = false, 1500);
                }
            },
            async dashboardDetail() {
                this.isLoading = true;
                await this.agentDashboardAction().then(res => {
                  if (res.success == true) {
                        this.dashboard = res.data
                        this.isLoading = false
                    }
                }).catch(err => this.isLoading = true)
            },
            toOrder(status) {
                this.$router.replace({ path: 'order-list', query: { page: 1, orderBy: 'desc', sortKey: 'created_at', limit: 10, fromDate: '', toDate: '', status: status, userId: '', email: '', orderNo: '' } }).catch(()=>{})
            },
        },
        async mounted() {
            this.isLoading = true
            const userStr = window.localStorage.getItem('user');
            if (userStr) {
                try {
                    this.user = JSON.parse(userStr);
                } catch (e) {
                    this.user = null;
                }
            }
            this.dashboardDetail()
        }
    }
</script>


<style scoped lang="scss">
    .dashboard-header {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        background: linear-gradient(90deg, #2B3A42 0%, #4F8A8B 100%);
        border-radius: 12px;
        padding: 18px 32px;
        margin-bottom: 24px;
        box-shadow: 0 2px 8px rgba(44, 62, 80, 0.08);
    }
    .dashboard-header h2 {
        color: #fff;
        font-size: 2rem;
        font-weight: 700;
        margin: 0;
        letter-spacing: 1px;
        text-shadow: 0 2px 8px rgba(44, 62, 80, 0.10);
    }
    .title-font-size {
        font-size: 1.25rem;
    }
    .card-font-size {
        font-size: 1.5rem;
    }
</style>